<app-multiple-select-filter [parentFormGroup]="parentFormGroup"
                   noEntriesFoundLabel="Aucun élément trouvé"
                   [parentFormControlName]="parentFormControlName"
                   [elements]="lovValues"
                   [filterElementProcessor]="filterLovValues"
                   [loading]="loadingElements"
                   [newItemModalOptions]="formattedNewItemModalOptions">
  <ng-template template-content let-element='element'>
    {{element.label}}
  </ng-template>

</app-multiple-select-filter>
